import * as z$1 from "zod/v4";
//#region src/schemas/http/space-history-navigation.ts
const spaceHistoryNavigationQuerySchema = z$1.strictObject({
	startSignalId: z$1.string().min(1).max(200).optional(),
	endSignalId: z$1.string().min(1).max(200).optional()
});
const spaceHistoryNavigationSchema = z$1.object({
	entries: z$1.array(z$1.object({
		signalId: z$1.string(),
		endSignalId: z$1.string(),
		startAt: z$1.number(),
		endAt: z$1.number(),
		count: z$1.number().int().positive(),
		author: z$1.string(),
		preview: z$1.string().max(360)
	})).max(48),
	total: z$1.number().int().nonnegative()
});
//#endregion
export { spaceHistoryNavigationQuerySchema, spaceHistoryNavigationSchema };

//# sourceMappingURL=space-history-navigation.js.map